/* @generated */
import * as React from "react";
const ThemeContext = React.createContext({
  mode: null,
  theme: null
});
export {
  ThemeContext
};
